import styled from 'styled-components'

import { Infos as GSInfos } from 'components/general-styles/General'
import { theme } from 'styles/theme'

const { media, space, colors } = theme

export const Section = styled.section`
  position: relative;
  width: 100%;
  padding-bottom: ${space['spacing-xxxl']};
  background-color: ${colors['neutral-background-medium']};

  @media (${media.tablet}) {
    padding-bottom: 0;
  }
`

export const ImageMobWrapper = styled.div`
  width: calc(100% + ${space['spacing-xxl']});
  margin-left: -${space['spacing-md']};
  padding: 0 ${space['spacing-md']};
  background: linear-gradient(180deg, rgb(255 255 255 / 100%) 75%, rgb(240 240 242 / 100%) 25%);

  @media (${media.tablet}) {
    display: none;
  }
`

export const ImageMob = styled.div`
  position: relative;
`

export const ImageDesk = styled.div`
  display: none;

  @media (${media.tablet}) {
    display: block;
    position: absolute;
    inset: 0;
    width: 100%;
    max-width: 45%;
  }

  @media (${media.desktop}) {
    max-width: min(631.65px, 45%);
  }
`

export const Infos = styled(GSInfos)`
  margin-top: ${space['spacing-md']};

  @media (${media.tablet}) {
    margin: ${space['spacing-xl']} 0;
  }

  @media (${media.desktop}) {
    margin: 7.5rem 0;
  }
`
